<template>
  <span class="voucher-replenishment-status">
    {{ exhausted ? 'Agotado · Reponer' : `${remaining} disponibles · Reponer` }}
  </span>
</template>

<script>
export default {
  name: "VoucherReplenishmentStatus",
  props: {
    exhausted: { type: Boolean, default: false },
    remaining: { type: Number, default: 0 },
  },
};
</script>

<style scoped>
.voucher-replenishment-status {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0.25rem 0.5rem;
  border: 1px solid #b91c1c;
  border-radius: 0.5rem;
  background: #dc2626;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.5;
  animation: voucherReplenishmentPulse 1.8s ease-in-out infinite;
}
@keyframes voucherReplenishmentPulse {
  0%, 100% { background-color: #dc2626; box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.45); }
  50% { background-color: #991b1b; box-shadow: 0 0 0 3px rgba(220, 38, 38, 0); }
}
@media (prefers-reduced-motion: reduce) {
  .voucher-replenishment-status { animation: none; }
}
</style>
